/**
 * @deprecated use account colors instead.
 */
export const calendarColors = ['gray', 'red', 'orange', 'yellow', 'green', 'teal', 'blue', 'indigo', 'purple', 'pink'];

/**
 * Those colors were used before the creation of the Account Colors feature that uses hexadecimal values.
 *
 * The now called legacy colors are used by concatenating its name with a tailwind shade.
 * e.g.: `red-500` `bg-blue-500`
 */
export namespace LegacyColors {
  export const colors = [...calendarColors];

  export const colorMap = {
    gray: '#6B7280',
    red: '#F05252',
    orange: '#FF5A1F',
    yellow: '#C27803',
    green: '#0E9F6E',
    teal: '#0694A2',
    blue: '#3F83F8',
    indigo: '#6875F5',
    purple: '#9061F9',
    pink: '#E74694',
  };
}
